import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const LANGUAGE_KEY = 'sportsdesign_lang';

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem(LANGUAGE_KEY) || 'en';
  });

  useEffect(() => {
    localStorage.setItem(LANGUAGE_KEY, language);
    // Keep dir always 'ltr' so section alignment (logo left, etc.) stays the same - only translate text
    document.documentElement.dir = 'ltr';
    document.documentElement.lang = language === 'ar' ? 'ar' : 'en';
  }, [language]);

  const setLanguage = (lang) => {
    setLanguageState(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
